import dynamic from 'next/dynamic';

const LockScreen = dynamic(() => import('./LockScreen'), { ssr: false });

export default LockScreen;
